"use strict";

module.exports = "\n  <div class=\"control-progress\">\n    <div class=\"progress-inner\">\n      <span class=\"reached\" style=\"width:{progress}%\"></span>\n      <span class=\"indicator\" style=\"left:{progress}%\"></span>\n    </div>\n  </div>\n";